import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as moment from 'moment';
import {
  VbScheduledChangeNotice,
  VbScheduledChangeOutcomeEnum
} from '../../create-vb-payment-change-components/utils/vb-payment-change-review-step.utils';

interface VbScheduledChangeSentence {
  isPlural: boolean;
  months: string;
}

@Component({
  selector: 'app-vb-scheduled-change-notice',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './vb-scheduled-change-notice.component.html',
  styleUrls: ['./vb-scheduled-change-notice.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbScheduledChangeNoticeComponent implements OnChanges {
  @Input({ required: true }) notices!: VbScheduledChangeNotice[];
  @Input() isLumpSum: boolean = false;

  public replaces: VbScheduledChangeSentence | null = null;
  public cancels: VbScheduledChangeSentence | null = null;

  public ngOnChanges(): void {
    this.replaces = this.buildSentence(VbScheduledChangeOutcomeEnum.Replaces);
    this.cancels = this.buildSentence(VbScheduledChangeOutcomeEnum.Cancels);
  }

  private buildSentence(outcome: VbScheduledChangeOutcomeEnum): VbScheduledChangeSentence | null {
    const scheduledDates = this.notices
      .filter(notice => notice.outcome === outcome)
      .map(notice => notice.scheduledDate)
      .sort();
    if (!scheduledDates.length) return null;

    const months = [...new Set(scheduledDates.map(date => moment.utc(date).format('MMMM YYYY')))];
    return { isPlural: scheduledDates.length > 1, months: months.join($localize` and `) };
  }
}
